import semver from 'semver';
import releaseNotes from './notes';

// Notas publicadas até a versão em uso, da mais nova para a mais antiga.
export const notesUpTo = (currentVersion, notes = releaseNotes) => {
  if (!semver.valid(currentVersion)) return [];

  return notes
    .filter(note => semver.lte(note.version, currentVersion))
    .sort((a, b) => semver.rcompare(a.version, b.version));
};

// Datas das notas vêm como AAAA-MM-DD; o locale do Chatwoot usa '_' (pt_BR),
// que o Intl não aceita.
export const formatNoteDate = (date, locale) =>
  new Date(`${date}T12:00:00`).toLocaleDateString(locale.replace('_', '-'));

export const NOTE_LOCALES = ['pt_BR', 'en', 'es'];
const FALLBACK_LOCALE = 'en';

// Texto no idioma da interface; 'pt' e 'es_*' caem no idioma base (pt_BR, es)
// e qualquer outro idioma cai no inglês.
export const localizeNoteText = (text, locale) => {
  const language = locale.split('_')[0];
  const key = text[locale]
    ? locale
    : NOTE_LOCALES.find(noteLocale => noteLocale.split('_')[0] === language);

  return text[key] || text[FALLBACK_LOCALE];
};

// O que o usuário ainda não viu. Quem nunca viu nenhuma (usuário novo ou
// primeira versão com a tela) recebe só a versão mais recente, não o histórico.
export const unseenNotes = (currentVersion, lastSeenVersion, notes) => {
  const published = notesUpTo(currentVersion, notes);
  if (!semver.valid(lastSeenVersion)) return published.slice(0, 1);

  return published.filter(note => semver.gt(note.version, lastSeenVersion));
};
